import { CreatePdfiumFactory, type PdfiumApi } from "@pdfking/pdfium-wrap"
import { CreateSingleton, LockManager } from "@pdfking/tfunc"

const INIT_TIMEOUT_SECONDS = 1
const DISPOSE_TIMEOUT_SECONDS = 5

let currentApi: PdfiumApi | undefined
let initTimer: ReturnType<typeof setTimeout> | undefined
let disposeTimer: ReturnType<typeof setTimeout> | undefined
let activeSessions = 0

const { schedule: lockSchedule } = LockManager()

const clearTimers = (onInit = true, onDispose = true) => {
  if (onInit && initTimer) {
    clearTimeout(initTimer)
    initTimer = undefined
  }
  if (onDispose && disposeTimer) {
    clearTimeout(disposeTimer)
    disposeTimer = undefined
  }
}

const schedule = (
  func: () => Promise<void>,
  onInit: boolean = true,
  onDispose: boolean = true
) => lockSchedule("λ", func).then(() => clearTimers(onInit, onDispose))

const loader = CreateSingleton(CreatePdfiumFactory)

export async function* ProvisionPdfium<T>(
  fn: (api: PdfiumApi) => AsyncGenerator<T>
): AsyncGenerator<T> {
  const factory = await loader()
  await schedule(async () => {
    activeSessions++
    if (!currentApi) {
      currentApi = await factory()
      // console.info("PDFSession: create", currentApi.id)
    }
  })

  try {
    yield* fn(currentApi!)
  } finally {
    activeSessions--
    clearTimers()
    if (activeSessions === 0) {
      initTimer = setTimeout(
        () =>
          schedule(
            async () => {
              // console.info("PDFSession: init", currentApi?.id)
              await currentApi?.init()
            },
            true,
            false
          ),
        INIT_TIMEOUT_SECONDS * 1000
      )
      disposeTimer = setTimeout(
        () =>
          schedule(
            async () => {
              // console.info("PDFSession: dispose", currentApi?.id)
              currentApi?.dispose()
              currentApi = undefined
            },
            false,
            true
          ),
        DISPOSE_TIMEOUT_SECONDS * 1000
      )
    }
  }
}
